// test2318
(2318 && 0);
